import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/system';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableSortLabel from '@mui/material/TableSortLabel';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import { addDays } from "date-fns";
import moment from 'moment';
import Select from '@mui/material/Select';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import logoImage from './images/logo.jpg';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import csvimage from './images/csvimage.png';
import psdfimage from './images/psdfimage.png';
//new
import { useNavigate } from 'react-router-dom';
export function withNavigation(Component) {
  return props => <Component {...props} navigate={useNavigate()} />;
}
const headCells = [
    { id: 'or_createddate', numeric: false, label: ' ' },
    { id: 'total', numeric: false, label: ' ' },
	{ id: 'total', numeric: false, label: ' ' },{ id: 'total', numeric: false, label: ' ' },
];
function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}
function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };
}
EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};
const useStyles = styled({ 
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
    icon: {
        verticalAlign: 'middle',
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
});
//new
class Profitlossreport extends Component {
    revenueCodes = ['4000', '4050', '4100', '4200', '4300', '4400', '4900'];
    costOfSalesCodes = ['5000', '5400', '5450', '5900'];
    constructor(props) {
        super(props);
        var strdob = new Date();
        var month = "";
        if ((strdob.getMonth() + 1) < 10) {
            month = "0" + (strdob.getMonth() + 1);
        } else {
            month = (strdob.getMonth() + 1);
        }
        const currentDate = new Date();
        var month1 = (currentDate.getMonth() + 1 < 10) ? "0" + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);
        var lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        var lastDay = (lastDayOfMonth.getDate() < 10) ? "0" + lastDayOfMonth.getDate() : lastDayOfMonth.getDate();
        this.state = {
            redirect: false,
            orderdata: [],
            paytype: "",
            page: 0, prevpage: 0, totaldata: 0, rowsPerPage: 50, rowsPaging: [], order: 'desc', orderBy: '', cusname: '', phone: '', or_ordernumber: '', sv_title: '',
            paidstatus: '', SevaArra: [], todate1: currentDate.getFullYear() + '-' + month1 + '-' + lastDay, todate: lastDayOfMonth,
            fromdate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1), openExportDialog: false,
            fromdate1: currentDate.getFullYear() + '-' + month1 + '-' + '01', or_phoneno: '',
            or_id: '', or_type: '', OrderProdData: [], paymentToDate: addDays(moment().toDate(), 0),
            ReportData: [],
            btndisabled: false,
            analysisType: '1',
            analysisCategory: '',
            isselectdisplay: false,
            fromDateEnabled: false,
            toDateEnabled: false,iscalculatetrue:false,
        }
        this.componentRef = React.createRef();
        this.addResendqrcode = React.createRef();
    }
    Search() {
        this.setState({
            page: 0,
            rowsPerPage: 50,
            prevpage: 0,
            orderdata: [],
            OrderProdData: [],
        });
        this.apicall(this.state.page, this.state.rowsPerPage);
    }
    componentDidMount() {
        document.title = "Profit & Loss Report";
		 this.props.parentdasCallback("Profit and Loss Report - Standard~");
		  if(localStorage.getItem("ISIuserid")==null)
		  {
		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
		if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
  this.apicall();			  
		  }
		  else{	    
		this.PageAccessCheckApi();
         }
}
    }
	PageAccessCheckApi() {
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=25')
  .then(resp => {
	  let strreturn=resp.data;
      if (strreturn!==0) {
  this.apicall();
      } else {
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
  });
}
    handleClickSearch = () => {
        this.apicall();
    }
	 HandleCaluclate = () => {
      this.setState({iscalculatetrue:!this.state.iscalculatetrue});
    }
    handleRequestSort = (event, property) => {
        const isAsc = this.state.orderBy === property && this.state.order === 'asc';
        this.setState({
            orderBy: property,
            order: isAsc ? 'desc' : 'asc'
        });
    };
    myChangeHandler = (event) => {
        let nam = event.target.name;
        let val = event.target.value;
        this.setState({
            [nam]: val
        });
    }
//new
handleRowClick = (ledgerId) => {
    const { fromdate1, todate1 } = this.state;
    this.props.navigate(
        `/transactionreport?ledger_id=${ledgerId}&from=${fromdate1}&to=${todate1}`
    );
};
    apicall() {
        const payload = {
            fromdate: this.state.fromdate1,
            todate: this.state.todate1,
            analysisType: this.state.analysisType,
            analysisCategory: this.state.analysisCategory
        };
        axios.get(localStorage.getItem("ISIurl") + 'ajaxreports.php?action=list&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&cmp_id='+localStorage.getItem('ISIcmpid'))
            .then(resp => {
                let reportDataArray = [];
                if (Array.isArray(resp.data)) {
                    reportDataArray = resp.data;
                } else if (resp.data && Array.isArray(resp.data.data)) {
                    reportDataArray = resp.data.data;
                }
                if (reportDataArray.length > 0) {
                    this.setState({
                        ReportData: reportDataArray,
                        totaldata: reportDataArray.length,
                    });
                } else {
                    this.setState({ ReportData: [], totaldata: 0 });
                }
            })
    }
    onchangedateHandler = (event) => {
        let selectedOption = event.target.value;
        const periodMap = {
            'This Month': [dayjs().startOf('month'), dayjs().endOf('month')],
            'This Quarter': [dayjs().startOf('month'), dayjs().endOf('month').add(3, 'month')],
            'This Year': [dayjs().startOf('year'), dayjs().endOf('year')],
            'Last Month': [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
            'Last Quarter': [dayjs().endOf('month'), dayjs().startOf('month').subtract(3, 'month')],
            'Last Year': [dayjs().subtract(1, 'year').startOf('year'), dayjs().subtract(1, 'year').endOf('year')],
            'This Financial Year': [dayjs().startOf('year').add(3, 'month'), dayjs().endOf('year').add(3, 'month')],
            'Last Financial Year': [dayjs().subtract(1, 'year').subtract(8, 'month'), dayjs().startOf('year').add(2, 'month')],
            'Custom': [dayjs(), dayjs().endOf('month')]
        };
        if (selectedOption === 'Custom') {
            this.setState({
                fromdate: periodMap['Custom'][0],
                todate: periodMap['Custom'][1],
                fromdate1: periodMap['Custom'][0].format('YYYY-MM-DD'),
                todate1: periodMap['Custom'][1].format('YYYY-MM-DD'),
                fromDateEnabled: true,
                toDateEnabled: true
            });
        } else {
            this.setState({
                fromdate: periodMap[selectedOption][0],
                todate: periodMap[selectedOption][1],
                fromdate1: periodMap[selectedOption][0].format('YYYY-MM-DD'),
                todate1: periodMap[selectedOption][1].format('YYYY-MM-DD'),
                fromDateEnabled: false,
                toDateEnabled: false
            });
        }
    };
    fromdatehandler = (date) => {
        var month = "";
        var date1 = new Date(date);
        if ((date1.getMonth() + 1) < 10) {
            month = "0" + (date1.getMonth() + 1)
        } else { month = (date1.getMonth() + 1) }
        this.setState({
            fromdate: dayjs(date),
            fromdate1: date1.getFullYear() + '-' + month + '-' + date1.getDate(),
        })
    }
    todatehandler = (date) => {
        var month = "";
        var date1 = new Date(date);
        if ((date1.getMonth() + 1) < 10) {
            month = "0" + (date1.getMonth() + 1)
        } else { month = (date1.getMonth() + 1) }
        this.setState({
            todate: dayjs(date),
            todate1: date1.getFullYear() + '-' + month + '-' + date1.getDate(),
        })
    }
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage });
    };
    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: +event.target.value, page: 0 });
    };
    Handleclickviewmore = (e) => {
        this.setState({ isselectdisplay: true });
    }
    CloseMoreoption = (date) => {
        this.setState({ isselectdisplay: false });
    }
    handleDownload = () => {
        const { ReportData, fromdate, todate } = this.state;
        const doc = new jsPDF();
        const imgWidth = 40;
        const imgHeight = 12;
        const imgX = (doc.internal.pageSize.width - imgWidth) / 2;
        const imgY = 5;
        doc.addImage(logoImage, 'JPEG', imgX, imgY, imgWidth, imgHeight);
        const title = 'Profit & Loss Report';
        doc.setFontSize(16);
        const titleY = 20;
        doc.text(title, doc.internal.pageSize.width / 2, titleY, { align: 'center' });
        const dateRange = `From: ${dayjs(fromdate).format('DD/MM/YYYY')} To: ${dayjs(todate).format('DD/MM/YYYY')}`;
        doc.setFontSize(10);
        doc.text(dateRange, doc.internal.pageSize.width / 2, titleY + 8, { align: 'center' });
        const tableStartY = titleY + 20;
        const revenues = [];
        const costOfSales = [];
        const expenses = [];
        let salesFeesDiscount = 0;
        (ReportData || []).forEach(item => {
            const leCode = item.le_code;
            const total = parseFloat(item.total || 0);
            if (leCode === '4900') {
                salesFeesDiscount = total;
                revenues.push({ ...item, total: total });
            } else if (this.revenueCodes.includes(leCode)) {
                revenues.push({ ...item, total: total });
            } else {
                if (this.costOfSalesCodes.includes(leCode)) {
                    costOfSales.push({ ...item, total: total });
                } else {
                    expenses.push({ ...item, total: total });
                }
            }
        });
        let totalRevenues = revenues.reduce((sum, item) => sum + item.total, 0);
        totalRevenues = totalRevenues - salesFeesDiscount;
        const totalCostOfSales = costOfSales.reduce((sum, item) => sum + item.total, 0);
        const totalExpenses = expenses.reduce((sum, item) => sum + item.total, 0);
        const grossProfitLoss = totalRevenues - totalCostOfSales;
        const netProfitLoss = grossProfitLoss - totalExpenses;
        const tableData = [];
        tableData.push([{ content: 'Revenues', colSpan: 3, styles: { fontStyle: 'bold', fillColor: '#e0e0e0' } }]);
        if (revenues.length > 0) {
            stableSort(revenues, getSorting(this.state.order, this.state.orderBy)).forEach(item => {
                tableData.push([`    ${item.le_code} - ${item.le_ledgername}`, { content: parseFloat(item.total).toFixed(2), styles: { halign: 'right' } }]);
            });
        } else {
            tableData.push([{ content: 'No revenue items found', colSpan: 2 }]);
        }
        tableData.push(['Total Revenues', { content: totalRevenues.toFixed(2), styles: { fontStyle: 'bold', halign: 'right' } }]);
        tableData.push([{ content: 'Cost of Sales', colSpan: 2, styles: { fontStyle: 'bold', fillColor: '#e0e0e0', cellPadding: { top: 10, bottom: 5 } } }]);
        if (costOfSales.length > 0) {
            stableSort(costOfSales, getSorting(this.state.order, this.state.orderBy)).forEach(item => {
                tableData.push([`    ${item.le_code} - ${item.le_ledgername}`, { content: parseFloat(item.total).toFixed(2), styles: { halign: 'right' } }]);
            });
        } else {
            tableData.push([{ content: 'No cost of sales items found', colSpan: 2 }]);
        }
        tableData.push(['Total Cost of Sales', { content: totalCostOfSales.toFixed(2), styles: { fontStyle: 'bold', halign: 'right' } }]);
        tableData.push([{ content: 'Gross Profit / Loss', colSpan: 1, styles: { fontStyle: 'bold' } }, { content: grossProfitLoss.toFixed(2), styles: { fontStyle: 'bold', halign: 'right' } }]);
        tableData.push([{ content: 'Expenses', colSpan: 2, styles: { fontStyle: 'bold', fillColor: '#e0e0e0', cellPadding: { top: 10, bottom: 5 } } }]);
        if (expenses.length > 0) {
            stableSort(expenses, getSorting(this.state.order, this.state.orderBy)).forEach(item => {
                tableData.push([`    ${item.le_code} - ${item.le_ledgername}`, { content: parseFloat(item.total).toFixed(2), styles: { halign: 'right' } }]);
            });
        } else {
            tableData.push([{ content: 'No expense items found', colSpan: 2 }]);
        }
        tableData.push(['Total Expenses', { content: totalExpenses.toFixed(2), styles: { fontStyle: 'bold', halign: 'right' } }]);
        tableData.push([{ content: 'Net Profit/Loss', colSpan: 1, styles: { fontStyle: 'bold', fontSize: 11, lineColor: [0, 0, 0], lineWidth: 0.5, borderTop: 2 } }, { content: netProfitLoss.toFixed(2), styles: { fontStyle: 'bold', fontSize: 11, halign: 'right', lineColor: [0, 0, 0], lineWidth: 0.5, borderTop: 2 } }]);
        doc.autoTable({
            startY: tableStartY,
            head: [['Account', 'Amount']],
            body: tableData,
            theme: 'grid',
            styles: { overflow: 'linebreak' },
            columnStyles: {
                0: { cellWidth: 'auto' },
                1: { cellWidth: 50, halign: 'right' },
            },
            didDrawPage: function (data) {
                var str = "Page " + doc.internal.getNumberOfPages();
                doc.setFontSize(10);
                doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
            },
            margin: { top: 30 }
        });
        doc.save('ProfitAndLossReport.pdf');
    };
    handleOpenExportDialog = () => {
        this.setState({ openExportDialog: true });
    };
    handleCloseExportDialog = () => {
        this.setState({ openExportDialog: false });
    };
    render() {
        if (this.state.redirect === true) {
            return <Navigate to={this.state.pagename} />
        }
        const { ReportData } = this.state;
        const revenues = [];
        const costOfSales = [];
        const expenses = [];
        let salesFeesDiscount = 0;
        (ReportData || []).forEach(item => {
            const leCode = item.le_code;
            const total = parseFloat(item.total || 0);
            if (leCode === '4900') {
                salesFeesDiscount = total;
                revenues.push({ ...item, total: total });
            } else if (this.revenueCodes.includes(leCode)) {
                revenues.push({ ...item, total: total });
            } else if (this.costOfSalesCodes.includes(leCode)) {
                costOfSales.push({ ...item, total: total });
            } else {
                expenses.push({ ...item, total: total });
            }
        });
        let totalRevenues = revenues.reduce((sum, item) => sum + item.total, 0);
        totalRevenues = totalRevenues - salesFeesDiscount;
        const totalCostOfSales = costOfSales.reduce((sum, item) => sum + item.total, 0);
        const totalExpenses = expenses.reduce((sum, item) => sum + item.total, 0);
        const netProfitLoss = totalRevenues - totalCostOfSales - totalExpenses;
        const numberOfColumns = headCells.length;
        return (
            <React.Fragment>
                <div className="searchbox">
                    <ul>
                        <li>
                            <p>Period</p>
                            <p>
                                <Select
                                    native
                                    variant="outlined"
                                    className="txtbox"
                                    margin="normal"
                                    fullWidth
                                    onChange={this.onchangedateHandler}
                                    inputProps={{ tabIndex: '4' }}
                                >
                                    <option>This Month</option>
                                    <option>This Quarter</option>
                                    <option>This Year</option>
                                    <option>Last Month</option>
                                    <option>Last Quarter</option>
                                    <option>Last Year</option>
                                    <option>This Financial Year</option>
                                    <option>Last Financial Year</option>
                                    <option>Custom</option>
                                </Select>
                            </p>
                        </li>
                        <li>
                            <p>From Date</p>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker
                                        disabled={!this.state.fromDateEnabled}
                                        value={dayjs(this.state.fromdate)}
                                        className="txtbox"
                                        onChange={this.fromdatehandler}
                                        format="MM/DD/YYYY"
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                        </li>
                        <li>
                            <p>To Date</p>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker
                                        disabled={!this.state.toDateEnabled}
                                        value={dayjs(this.state.todate)}
                                        className="txtbox"
                                        onChange={this.todatehandler}
                                        format="MM/DD/YYYY"
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                        </li>
                        <li>
                            <p>&nbsp;</p>
                            <p className="searchbutton">
							 <Button type="submit" variant="contained" className="frmSecondarybtn" onClick={this.handleClickSearch}>
                                    Search
                                </Button>
							 &nbsp;
                                <Button type="submit" variant="contained" className="frmSecondarybtn" onClick={this.HandleCaluclate}>
                                    Calculate
                                </Button>
                                &nbsp;
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className="exportbtn"
                                    onClick={this.handleOpenExportDialog}
                                >
                                    EXPORT
                                </Button>
                            </p>
                        </li>
                    </ul>
                    <div className="clear"></div>
                    <div ref={el => (this.componentRef = el)}>
                        <TableContainer>
                            <Table id="profitlossreport" stickyHeader aria-label="sticky table">
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={2} style={{ fontWeight: 'bold', backgroundColor: '#e0e0e0' }}>
                                            Revenues
                                        </TableCell>
										 <TableCell>
										  </TableCell>
                                    </TableRow>
                                    {revenues.length > 0 ? (
                                        stableSort(revenues, getSorting(this.state.order, this.state.orderBy)).map((item, index) => (
                                           <TableRow
  key={`revenue-${index}`}
  hover
  style={{ cursor: "pointer" }}
  onClick={() => this.handleRowClick(item.le_code)}
>
                                                <TableCell>&nbsp;&nbsp;&nbsp;&nbsp;{item.le_code} - {item.le_ledgername}</TableCell>
                                                <TableCell align="right">{'\u200B' +parseFloat(item.total).toFixed(2)}</TableCell>
												   <TableCell>
										  </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={2}>No revenue items found</TableCell>
                                        </TableRow>
                                    )}
									{this.state.iscalculatetrue=== true && (
                                    <TableRow>
                                        <TableCell colSpan={2} style={{textAlign:'right', fontWeight: 'bold' }}>Total Revenues</TableCell>
                                        <TableCell align="right" style={{ fontWeight: 'bold' }}>{'\u200B' + parseFloat(totalRevenues || 0).toFixed(2)}</TableCell>
										
                                    </TableRow>
									)}
                                    {/* Cost of Sales Section */}
                                    <TableRow>
                                        <TableCell colSpan={3} style={{ fontWeight: 'bold', backgroundColor: '#e0e0e0', marginTop: '10px' }}>
                                            Cost of Sales
                                        </TableCell>
                                    </TableRow>
                                    {costOfSales.length > 0 ? (
                                        stableSort(costOfSales, getSorting(this.state.order, this.state.orderBy)).map((item, index) => (
                                            <TableRow
  key={`costofsales-${index}`}
  hover
  style={{ cursor: "pointer" }}
  onClick={() => this.handleRowClick(item.le_code)}
>
                                                <TableCell >&nbsp;&nbsp;&nbsp;&nbsp;{item.le_code} - {item.le_ledgername}</TableCell>
                                                <TableCell align="right">{'\u200B' +parseFloat(item.total).toFixed(2)}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={2}>No cost of sales items found</TableCell>
                                        </TableRow>
                                    )}
									{this.state.iscalculatetrue=== true && (
									<React.Fragment>
                                    <TableRow>
                                        <TableCell colSpan={2} style={{ textAlign:'right',fontWeight: 'bold' }}>Total Cost of Sales</TableCell>
                                        <TableCell align="right" style={{ fontWeight: 'bold' }}> {'\u200B' + parseFloat(totalCostOfSales || 0).toFixed(2)}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan={2}  style={{ textAlign:'right',fontWeight: 'bold' }}>Gross Profit / Loss</TableCell>
                                        <TableCell align="right" style={{ fontWeight: 'bold' }}> {'\u200B' + parseFloat((totalRevenues - totalCostOfSales) || 0).toFixed(2)}</TableCell>
                                    </TableRow>
									</React.Fragment>
									)}
                                    <TableRow>
                                        <TableCell colSpan={2} style={{ fontWeight: 'bold', backgroundColor: '#e0e0e0', marginTop: '10px' }}>
                                            Expenses
                                        </TableCell>
                                    </TableRow>
                                    {expenses.length > 0 ? (
                                        stableSort(expenses, getSorting(this.state.order, this.state.orderBy)).map((item, index) => (
                                          <TableRow
  key={`expense-${index}`}
  hover
  style={{ cursor: "pointer" }}
  onClick={() => this.handleRowClick(item.le_code)}
>
                                                <TableCell>&nbsp;&nbsp;&nbsp;&nbsp;{item.le_code} - {item.le_ledgername}</TableCell>
                                                <TableCell align="right">{'\u200B' +parseFloat(item.total).toFixed(2)}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={2}>No expense items found</TableCell>
                                        </TableRow>
                                    )}
									{this.state.iscalculatetrue=== true && (
                                    <TableRow >
                                        <TableCell colSpan={2} style={{ textAlign:'right',fontWeight: 'bold' }}>Total Expenses</TableCell>
                                        <TableCell align="right" style={{ fontWeight: 'bold' }}> {'\u200B' + parseFloat(totalExpenses || 0).toFixed(2)}</TableCell>
                                    </TableRow>
									)}
									{this.state.iscalculatetrue=== true && (
                                    <TableRow  style={{ borderTop: '2px solid black' }}>
                                        <TableCell colSpan={2} style={{ textAlign:'right',fontWeight: 'bold', fontSize: '1.1em' }}>Net Profit/Loss</TableCell>
                                        <TableCell colSpan={2} align="right" style={{ fontWeight: 'bold', fontSize: '1.1em' }}> {'\u200B' + parseFloat(netProfitLoss || 0).toFixed(2)}</TableCell>
                                    </TableRow>
									)}
                                    {this.state.totaldata === 0 && (
                                        <TableRow key={0} >
                                            <TableCell align="center" colSpan={2}>No Records</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
                <Dialog open={this.state.openExportDialog} onClose={this.handleCloseExportDialog}>
                    <DialogTitle>Generated Detailed Profit and loss report</DialogTitle>
                    <DialogContent>
                        <p> To generate a new report, based on the latest selection criteria you've specified, choose the format
                            you want to use. Depending on the amount of data included on the report, it may take some time to generate.</p>
			<p style={{ textAlign: "center", display: "flex", justifyContent: "center", gap: "20px" }}>
  <ReactHTMLTableToExcel
    className="my-custom-excel-button"
    table="profitlossreport"
    filename="Profit & Loss Report"
    sheet="Profit & Loss Report"
    buttonText=""
  />
  <img
    src={psdfimage}
    width={100}
    height={100}
    style={{ cursor: "pointer" }}
    onClick={this.handleDownload}
    alt="Download PDF"
  />
</p>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseExportDialog} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}
   export class fromtodate extends Component {
  constructor(props) {
    super(props);
    this.state = {
		   fromdate: props.fromdate || new Date(),
      todate: props.todate || new Date(),
      fromdate1: props.fromdate1 || '',
      todate1: props.todate1 || '',
    };
  }
onchangedateHandler = (event) => {
  let selectedOption = event.target.value;
  const periodMap = {
    'This Month': [dayjs().startOf('month'), dayjs().endOf('month')],
   'This Quarter': [dayjs().startOf('month'), dayjs().endOf('month').add(3, 'month')],
    'This Year': [dayjs().startOf('year'), dayjs().endOf('year')],
    'Last Month': [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
    'Last Quarter': [dayjs().endOf('month'), dayjs().startOf('month').subtract(3, 'month')],
    'Last Year': [dayjs().subtract(1, 'year').startOf('year'), dayjs().subtract(1, 'year').endOf('year')],
	 'This Financial Year': [dayjs().startOf('Year').add(3, 'month'), dayjs().endOf('Year').add(3, 'month')],
	 'Last Financial Year': [dayjs().subtract(1, 'year').subtract(8, 'month'), dayjs().startOf('Year').add(2, 'month')],
    'Custom':[dayjs(), dayjs().endOf('month')]
  };
if (selectedOption === 'Custom') {
    this.setState({
      fromdate: periodMap['Custom'][0],
      todate: periodMap['Custom'][1],
      fromdate1: periodMap['Custom'][0].format('YYYY-MM-DD'),
      todate1: periodMap['Custom'][1].format('YYYY-MM-DD'),
      fromDateEnabled: true,
      toDateEnabled: true
    });
  } else {
    this.setState({
      fromdate: periodMap[selectedOption][0],
      todate: periodMap[selectedOption][1],
      fromdate1: periodMap[selectedOption][0].format('YYYY-MM-DD'),
      todate1: periodMap[selectedOption][1].format('YYYY-MM-DD'),
      fromDateEnabled: false,
      toDateEnabled: false
    });
  }
};
  todatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);
 this.setState({
    todate: dayjs(dateObj),
    todate1: dateObj.getFullYear() + '-' + (dateObj.getMonth() + 1) + '-' + dateObj.getDate(),
    toDateEnabled: true
  });
  }
  render() {
 return (
	 <React.Fragment>
	 <div className="searchbox">
<ul>
<li>
<p>Period</p> <p><Select
  native
  variant="outlined" className="txtbox"
  margin="normal"
  fullWidth 
  onChange={this.onchangedateHandler}
  inputProps={{tabIndex: "4"}}
        > <option>This Month</option>
          <option>This Quarter</option>
          <option>This Year</option>
          <option>Last Month</option>
          <option>Last Quarter</option>
          <option>Last Year</option>
          <option>This Financial Year</option>
          <option>Last Financial Year</option>
          <option>Custom</option>
  </Select></p>
</li>
<li>
<p><p>From Date</p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
  <DemoContainer components={['DatePicker']}>
    <DatePicker
      disabled={!this.state.fromDateEnabled}
      value={dayjs(this.state.fromdate)}
      className="txtbox"
      onChange={this.fromdatehandler}
      format="MM/DD/YYYY"
    />
  </DemoContainer>
</LocalizationProvider></p>
</li>
<li>
<p><p>To Date</p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
  <DemoContainer components={['DatePicker']}>
    <DatePicker
      disabled={!this.state.toDateEnabled}
      value={dayjs(this.state.todate)}
      className="txtbox"
      onChange={this.todatehandler}
      format="MM/DD/YYYY"
    />
  </DemoContainer>
</LocalizationProvider></p></li>
	</ul>
	</div>
	 </React.Fragment>
  )}
   }
   export default withNavigation(Profitlossreport);